import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import LinkView from 'lib/ui/link-view';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';
import URLBuilderable from 'lib/url/url-builderable';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import arrowEnter from 'four-nets/icons/svg/icon_last.svg';
import clock from 'four-nets/icons/svg/icon_time.svg';
import user from 'four-nets/icons/svg/icon_user.svg';
import BoxView from 'four-nets/ui/box-view';
import { UserLink } from 'four-nets/user/user-link';
import defaultStyles from './forum-widget-item-view.scss';

@Localizable()
@URLBuilderable()
@Styled(defaultStyles)
@observer
class ForumWidgetItemView extends React.Component {
    static contextTypes = {
        site: PropTypes.object,
    };

    render() {
        const { threadViewModel, styles, urlBuilder } = this.props;

        const lastMessageInThreadUrl = threadViewModel.lastMessageLink.href;
        const threadTitle = threadViewModel.lastMessageLink.label;

        const { site } = this.context;

        return (
            <li className={styles.forumWidgetItem}>
                {site.isGarden ? (
                    <LinkView link={threadViewModel.lastMessageLink} className={styles.link} />
                ) : (
                    <a href={lastMessageInThreadUrl} className={styles.link}>
                        {threadTitle}
                    </a>
                )}
                {threadViewModel.badges &&
                    threadViewModel.badges.map((badge, index) => (
                        <span key={`${index.toString()}`} className={styles.box}>
                            <BoxView mini={true}>{badge}</BoxView>
                        </span>
                    ))}
                <span className={styles.section}>
                    <span className={styles.centerer}>
                        <SVGIcon style={{ image: styles.icon }} src={user} />
                        <LinkView
                            link={
                                new UserLink({
                                    user: threadViewModel.author,
                                    urlBuilder,
                                })
                            }
                            className={styles.sectionLink}
                        />
                        ,
                    </span>
                </span>
                <span className={styles.section}>
                    {site.isGarden ? (
                        <LinkView link={threadViewModel.lastMessageLink} className={styles.sectionLink}>
                            <span className={styles.centerer}>
                                <SVGIcon style={{ image: styles.icon }} src={clock} />
                                <FormattedDateAgoView value={threadViewModel.date} />
                                <span>
                                    <SVGIcon
                                        style={{ image: styles.icon }}
                                        src={arrowEnter}
                                        className={styles.enterIcon}
                                    />
                                </span>
                            </span>
                        </LinkView>
                    ) : (
                        <a href={lastMessageInThreadUrl} className={styles.sectionLink}>
                            <span className={styles.centerer}>
                                <SVGIcon style={{ image: styles.icon }} src={clock} />
                                <FormattedDateAgoView value={threadViewModel.date} />
                                <span>
                                    <SVGIcon
                                        style={{ image: styles.icon }}
                                        src={arrowEnter}
                                        className={styles.enterIcon}
                                    />
                                </span>
                            </span>
                        </a>
                    )}
                </span>
            </li>
        );
    }
}

export default ForumWidgetItemView;
